import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import CategoryServices from "../../../services/Category";
import CategoryForm from "./categoryForm";

const CreateCategory = () => {

  const route = all_routes;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const createCategory = async (formData) => {
    setLoading(true)
    try {
      await CategoryServices.createCategory(formData)
      SuccessToaster('Create Successfully')
      navigate(route?.categories)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Category</h4>
              <h6>Create new category</h6>
            </div>
          </div>
        </div>
        <CategoryForm onSubmit={createCategory} loading={loading} />
      </div >
    </div >
  );
};

export default CreateCategory;
